module.exports = __webpack_public_path__ + "assets/img/wlhy-ru.049ba896.jpg";